import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoreData } from "@builder/store/slices/BuilderSlice/types";
import { Company } from "@builder/types/Company.type";
import { UserFromToken } from "@builder/types/Users.type";

interface StoreDataState {
    initialLoad: boolean;
    isOrg?: boolean;
    company?: Company;
    selectedCompany?: string;
    user?: UserFromToken;
    data?: StoreData;
}

const initialState: StoreDataState = {
    initialLoad: true
};

const selectionSlice = createSlice({
    name: "selection",
    initialState,
    reducers: {
        setIsOrg: (state, action: PayloadAction<boolean>) => {
            state.isOrg = action.payload;
        },
        setCompany: (state, action: PayloadAction<Company>) => {
            state.company = action.payload;
        },
        setStoreData: (state, action: PayloadAction<Partial<StoreData>>) => {
            state.data = { ...state.data, ...action.payload };
        },
        setUser: (state, action: PayloadAction<UserFromToken>) => {
            state.user = action.payload;
        },
        setInitialLoad: (state, action: PayloadAction<boolean>) => {
            state.initialLoad = action.payload;
        }
    }
});

export const { setCompany, setStoreData, setUser, setIsOrg, setInitialLoad } = selectionSlice.actions;
export default selectionSlice.reducer;
